import React from "react";
import styles from "./styles.module.css";
import { MdDragHandle, MdExpandMore } from "react-icons/md";
import { useDrag, useDrop } from "react-dnd";
import EditPage from "./editpage";

export default function PageCard({ page, handleDrop, onSelect, pages, path }) {
  const [open, setOpen] = React.useState(false);
  const handleExpand = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  const onDrop = (item, monitor) => {
    if (!monitor.isOver({ shallow: true })) {
      return;
    }
    handleDrop(item.page, item.path, path);
  };

  const [{}, dragRef] = useDrag({
    item: {
      type: "pagecard",
      page,
      path,
    },
    collect: (monitor, props) => ({
      dragging: monitor.isDragging(),
    }),
    canDrag: () => page.editable,
  });

  const [{ hovered }, dropRef] = useDrop({
    accept: "pagecard",
    drop: (...args) => onDrop(...args),
    collect: (monitor) => ({
      hovered: !!monitor.isOver({ shallow: true }),
    }),
  });

  return (
    <div
      ref={dropRef}
      className={
        hovered ? `${styles.pageCard} ${styles.hovered}` : styles.pageCard
      }
    >
      <div
        ref={dragRef}
        onClick={() => onSelect(page)}
        className={styles.pageCardItem}
      >
        {page.editable && <MdDragHandle style={{ cursor: "move" }} />}
        <div style={{ flexGrow: 1, marginLeft: 8 }}>{page.name}</div>
        {page.dynamic && <div style={{ margin: "0px 8px" }}>(dynamic)</div>}
        {page.editable && (
          <>
            <EditPage pagesNames={pages.map((x) => x.name)} page={page} />
            <MdExpandMore
              onClick={handleExpand}
              className={
                open ? `${styles.expandIcon} ${styles.open}` : styles.expandIcon
              }
            />
          </>
        )}
      </div>
      {open && (
        <Children
          children={pages.filter((x) => page.subpages.includes(x.id))}
          pages={pages}
          onSelect={onSelect}
          path={path}
          handleDrop={handleDrop}
        />
      )}
    </div>
  );
}

const Children = ({ children, pages, onSelect, path, handleDrop }) => {
  const onDrop = (item, monitor) => {
    if (!monitor.isOver({ shallow: true })) {
      return;
    }
    handleDrop(item.page, item.path, path, true);
  };
  const [{ hovered }, dropRef] = useDrop({
    accept: "pagecard",
    drop: (...args) => onDrop(...args),
    collect: (monitor) => ({
      hovered: !!monitor.isOver({ shallow: true }),
    }),
  });
  return (
    <div className={styles.pageChildren}>
      {children.map((p) => {
        return (
          <PageCard
            path={[...path, p.id]}
            onSelect={onSelect}
            pages={pages}
            key={p.id}
            page={p}
            handleDrop={handleDrop}
          />
        );
      })}
      <div
        ref={dropRef}
        className={
          hovered
            ? `${styles.childDropTarget} ${styles.hovered}`
            : styles.childDropTarget
        }
      >
        Drop Page Here
      </div>
    </div>
  );
};
